'use es6';

import { createSelector } from 'reselect';
import { getShowCompiledSplitScreen } from 'DesignData/selectors/codeEditor';
import { getUserSettings as getJavaScriptLinter } from 'DesignData/selectors/javaScriptLinter';
import { getShowGlobalContentMessage, getIsFinderShowing, getFinderWidth, getAlwaysShowFinderOnStartup, shouldUpdatePreviewer, getHasDismissedResponsiveImageWarning, getHasDismissedIconSetWarning, getHasDismissedAdvancedRelOptionsWarning, getHasDismissedAdvancedVideoOptionsWarning, getPinnedTabs } from 'DesignData/selectors/app';
/**
 * Get User specific application settings.
 * @return {Object}
 */

export const getUserSettings = createSelector([getShowGlobalContentMessage, getIsFinderShowing, getFinderWidth, getAlwaysShowFinderOnStartup, shouldUpdatePreviewer, getShowCompiledSplitScreen, getJavaScriptLinter, getHasDismissedResponsiveImageWarning, getHasDismissedIconSetWarning, getHasDismissedAdvancedRelOptionsWarning, getHasDismissedAdvancedVideoOptionsWarning, getPinnedTabs], (showGlobalContentMessage, isFinderShowing, finderWidth, alwaysShowFinderOnStartup, updatePreviewer, showCompiledSplitScreen, javaScriptLinter, hasDismissedResponsiveImageWarning, hasDismissedIconSetWarning, hasDismissedAdvancedRelOptionsWarning, hasDismissedAdvancedVideoOptionsWarning, pinnedTabs) => {
  return {
    showGlobalContentMessage,
    isFinderShowing,
    finderWidth,
    alwaysShowFinderOnStartup,
    updatePreviewer,
    showCompiledSplitScreen,
    javaScriptLinter,
    hasDismissedResponsiveImageWarning,
    hasDismissedIconSetWarning,
    hasDismissedAdvancedRelOptionsWarning,
    hasDismissedAdvancedVideoOptionsWarning,
    pinnedTabs
  };
});